import { DrawerActions } from '@react-navigation/native';
export function openDrawer() {
  return DrawerActions.openDrawer();
}
export function closeDrawer() {
  return DrawerActions.closeDrawer();
}
export function toggleDrawer() {
  return DrawerActions.toggleDrawer();
}
//# sourceMappingURL=DrawerActions.js.map